import is from 'is_js'
import {$dom} from '../../helpers/dom';

const {
	exist,
	get,
	attr
} = $dom;

export default function initContactsMap(mapId = 'map') {
	let map, canCreate = false;
	const idAttr = '#'+mapId;

	if (is.not.object(window.ymaps)) return ;

	const init = () => {

		if (!canCreate) return false;

		if (exist(idAttr)) {

			map = new ymaps.Map(mapId, {
				center: attr(get(idAttr), 'data-map-center').split(',').map(s => parseFloat(s)),
				zoom: 14
			}, {
				searchControlProvider: 'yandex#search'
			});

			const marker = new ymaps.Placemark(map.getCenter(), {
				hintContent: 'BusinessChain',
				balloonContent: 'Санкт-Петербург, пос. епино, Приморское шоссе, д.427'
			}, {
				iconLayout: 'default#image',
				iconImageHref: attr(get(idAttr), 'data-marker-url') || '',
				iconImageSize: [40, 60],
				iconImageOffset: [-20, -60]
			});

			map
				.geoObjects
				.add(marker)
		}

	};

	const destroy = () => {
		if (exist(idAttr) && map && is.function(map.destroy)) map.destroy()
	};

	ymaps.ready(() => {
		canCreate = true;
		init();
	});



	return {init, destroy}
}
